const maxLocationsNumberExceededMessage =
  "You've reached your maximum number of locations";

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Try again.';

export const API_ERROR_MESSAGES_KEYS = {
  'corp-id.invalid': 'Company ID does not match this organization',
  'corp-id.not_found': 'Company ID is invalid',
  'corp-id.required': 'Company ID is required',
  'client_id.already-exists': 'Firm ID already exists',
  'invoicing_method.invalid-invoicing-method-for-selected-invoice-payment-method':
    'You cannot create an account that pays by credit card and receives multiple invoices.',
  'corp.invoice_payment_method_max_amount':
    'FIG values out of sync. Contact Corporate Product and Technology.',
  'departments_required.departments-required-cannot-be-updated-if-corp-has-employees':
    'Departments cannot be made required if the client has already created employees.',
  'invoicing_method.update-not-allowed-when-switching-from-multi-to-single-invoicing':
    'Unable to change invoicing method. You cannot change an account from multiple invoice to single invoice once the first invoice has been generated for the account.',
  'locations_required.locations-required-cannot-be-updated-if-corp-has-employees':
    'Locations cannot be made required if the client has already created employees.',
  'name.firm-name-already-exists': 'Business name already exists',
  'email.invalid': 'Email format is not valid',
  'email.not_found': 'The employee was not found',
  'email.required': 'Email is required',
  'email.already-exists': "Diner's email already exists.",
  'diner-connection.invalid':
    'Employee not added. Contact your Client Success Manager to update your Provider Connection ID.',
  'phone_number.invalid': 'Please enter a valid phone number',
  'first_name.max-characters-exceeded':
    'First name must be 30 characters or less',
  'first_name.required': 'First name is required',
  'max_tags_allowed.max-tags-for-corp-exceeded': 'Max Groups for Corp exceeded',
  'name.tag-name-already-exists': 'this group already exists',
  'last_name.max-characters-exceeded':
    'Last name must be 30 characters or less',
  'last_name.required': 'Last name is required',
  'name.max-characters-exceeded': 'Name must be  30 characters or less',
  'name.required': 'Name is required',
  'role.invalid': 'Employee must be CORP_DINER or CORP_ADMIN',
  'role.required': 'Employee role is required',
  'name.invalid': "Corp won't be updated",
  'name.firm-name-null-or-empty':
    'Please enter a name for your business. Use at least 1 character.',
  'event-id.not-found': 'Ordering permission not found',
  'owner-id.not-found': 'Corp not found',
  'group-id.not_found': 'Group not found',
  'group-budgets.not_found': 'Ordering permission not found',
  'group-budgets.invalid':
    'The budget is greater than the max allowed (currently $10K).',
  'event_id.event-is-expired': 'Ordering permission expired',
  'diners_to_add_and_remove.diners_to_add.invalid': 'Diner not found',
  'invalid.diners_to_add_and_remove.diners_to_remove.invalid':
    'Diner not found',
  'sales_person_code.invalid': 'Sales Person ID is invalid',
  // TODO @asoliar add user-friendly messages when they are designed
  'step_status.current-step-completed': 'Current step is completed',
  'funnel_step.skipping-steps-not-allowed': 'Skipping steps is not allowed',
  'step_status.missing-company-details-data': 'Missing company details data',
  'step_status.missing-groups-data': 'Missing groups data',
  'step_status.missing-employees-data': 'Missing employees data',
  'step_status.missing-manage-employees-data':
    'Add an employee to at least 1 group to continue',
  'step_status.missing-invoice-settings-data': 'Missing invoice settings data',
  'parent_id.create-children-job-already-in-progress':
    'Another admin is editing this page right now. Please wait a moment and do not refresh the page or your progress will be lost.',
  'location count.max-locations-for-corp-exceeded':
    maxLocationsNumberExceededMessage,
  'location count.max-locations-for-corp-invoiced-by-location-exceeded':
    maxLocationsNumberExceededMessage,
  'balance.balance-create-buyer-failed': DEFAULT_ERROR_MESSAGE,
  'balance.balance-create-onboarding-failed': DEFAULT_ERROR_MESSAGE,
  'balance.balance-get-onboarding-failed': DEFAULT_ERROR_MESSAGE,
} as const;
